import * as React from 'react';
import { CommonRootState } from '@pec/aion-ui-core/combineReducers';
import { connect } from 'react-redux';
import { ConnectChildren } from '@pec/aion-ui-core/types/connectChildren';
import { DesktopNavComponent } from '../../components/Nav/DesktopNav';
import { getOptionsIfNeeded, toggleNavExpanded } from '@pec/aion-ui-core/actions/options';
import { Location } from 'history';
import { RootActions } from '@pec/aion-ui-core/combineActions';
import { ThunkDispatch } from 'redux-thunk';
import { DeepReadonly } from 'utility-types';
import { IUserOrganization } from '@pec/aion-ui-core/interfaces/userOrganization';
import { IOrganization } from '@pec/aion-ui-core/interfaces/organization';

const mapStateToProps = ({ options: { navExpanded: expanded } }: CommonRootState) => ({
  expanded
});

const mapDispatchToProps = (dispatch: ThunkDispatch<CommonRootState, null, RootActions>) => ({
  getOptionsIfNeeded: () => dispatch(getOptionsIfNeeded()),
  handleExpand: () => dispatch(toggleNavExpanded())
});

type OwnProps = {
  contentEl?: HTMLElement | null;
  sideNav?: JSX.Element;
  handleLogOut: () => void;
  userName: string | null;
  userId?: string;
  userEmail: string | null;
  includeCompanySearch: boolean;
  organizationId?: string;
  location: Location;
  userOrganizations: DeepReadonly<IUserOrganization[]> | null;
  organization: DeepReadonly<IOrganization> | null;
  hasFetchedUserOrganizations: boolean;
};

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & OwnProps & ConnectChildren;

class DesktopNav extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.getOptionsIfNeeded();
    this.toggleContentElSquished();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.expanded !== this.props.expanded) {
      this.toggleContentElSquished();
    }
  }

  toggleContentElSquished = () => {
    const { contentEl, expanded } = this.props;
    if (!contentEl) {
      return;
    }
    if (expanded) {
      if (!contentEl.className.includes('squished')) {
        contentEl.className += ' squished';
      }
    } else {
      contentEl.className = contentEl.className.replace(/ ?squished/, '');
    }
  };

  render() {
    return <DesktopNavComponent {...this.props} />;
  }
}

export const DesktopNavContainer = connect(mapStateToProps, mapDispatchToProps)(DesktopNav);
